export default {
  data () {
    return {
      baseURL: 'https://www.gleif.org/',
      lang: 'en',
      menuItems: [
        {
          route: 'lei-search/about-lei-search/how-to-use-lei-search',
          title: 'How to use',
        },
        {
          route: 'challenge-lei-data',
          title: 'Challenge LEI Data',
        },
        {
          route: 'access-and-use-lei-data',
          title: 'About LEI Data',
        },
      ],
      footerItems: [
        {
          route: 'imprint',
          title: 'Imprint',
        },
        {
          route: 'terms',
          title: 'Terms',
        },
        {
          route: 'lei-data-terms-of-use',
          title: 'LEI Data Terms of Use',
        },
        {
          route: 'privacy-policy',
          title: 'Privacy Policy',
        },
        {
          route: 'cookies',
          title: 'Cookies',
        },
        {
          route: 'sitemap',
          title: 'Sitemap',
        },
      ],
      overlay: false,
    }
  },
  computed: {},
  methods: {
    buildURL (route) {
      return `${this.baseURL}/${this.lang}/${this.subURL}/${route}`
    },
    showMenu () {
      document.body.style.overflowY = 'hidden'
      this.overlay = true
    },
    closeMenu () {
      document.body.style.overflowY = 'scroll'
      this.overlay = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/nav-bars.js